import { Link, useLocation } from "react-router-dom";

// Switcher reutilizable entre las 3 vistas de un mismo Proceso de Trabajo —
// compartido entre ProcesosTrabajoPage.tsx (Vista Visual/Vista Tabla) y
// KanbanProcesoPage.tsx (Vista Kanban) para no duplicar esta lógica en los
// dos lugares. Siempre conserva el proceso seleccionado en la URL. El link
// a Kanban además deja `state.from` con la URL actual (incluyendo
// ?proceso=&vista=), para que el BotonVolver del Kanban pueda volver
// exactamente a esta vista sin perder nada.
export function SelectorVistaProceso({
  procesoId,
  vistaActual,
  className = "",
}: {
  procesoId: string;
  vistaActual: "visual" | "tabla" | "kanban";
  className?: string;
}) {
  const location = useLocation();
  const actual = location.pathname + location.search;
  const base = "px-3 py-1.5 text-sm font-medium transition-colors";
  const activo = "bg-principal text-superficie";
  const inactivo = "bg-superficie text-texto-secundario hover:text-texto";

  return (
    <div className={`flex overflow-hidden rounded-lg border border-borde ${className}`}>
      <Link
        to={`/configuracion/procesos?proceso=${procesoId}&vista=visual`}
        replace
        className={`${base} ${vistaActual === "visual" ? activo : inactivo}`}
      >
        Vista Visual
      </Link>
      <Link
        to={`/configuracion/procesos?proceso=${procesoId}&vista=tabla`}
        replace
        className={`${base} ${vistaActual === "tabla" ? activo : inactivo}`}
      >
        Vista Tabla
      </Link>
      <Link
        to={`/procesos?proceso=${procesoId}`}
        state={{ from: actual }}
        className={`${base} ${vistaActual === "kanban" ? activo : inactivo}`}
      >
        Vista Kanban
      </Link>
    </div>
  );
}
